export default class ListMoveObservable {
  static moveObservers = Array()

  static start = [0, 0, 0]
  static end = [0, 0, 0]

  static touchStartListener = function (e) {
    var touch = e.touches[0] //获取第一个触点
    var x = Number(touch.pageX) //页面触点X坐标
    var y = Number(touch.pageY) //页面触点Y坐标
    ListMoveObservable.start = [x, y, new Date().getTime()]
  }

  static touchMoveListener = function (e) {

  }

  static touchEndListener = function (e) {
    let now = new Date().getTime()
    var touch = e.changedTouches[0] //获取第一个触点
    var x = Number(touch.pageX) //页面触点X坐标
    var y = Number(touch.pageY) //页面触点Y坐标
    ListMoveObservable.end = [x, y]
    let diffY = y - ListMoveObservable.start[1]
    let diffX = x - ListMoveObservable.start[0]
    let slotY = Math.abs(diffY)
    let slotX = Math.abs(diffX)
    if (slotY > slotX && slotY > 50) {
      if (diffY > 0) {
        // 下滑
        ListMoveObservable.notifyMoveChange(2, $(document).scrollTop() <= 20)
      } else {
        // 上滑
        ListMoveObservable.notifyMoveChange(1, $(document).scrollTop() >= ($(document).height() - $(window).height() - 80))
      }
    } else if (slotX > slotY && slotX > 50) {
      if (diffX > 0) {
        // 左滑
      } else {
        // 右滑
      }
    } else if (slotX <= 50 && slotY <= 50) {
      let timeDiff = now - ListMoveObservable.start[2]
      if (timeDiff > 150) {
        ListMoveObservable.notifyMoveChange(6)
      } else if (timeDiff >= 50 && timeDiff <= 150) {
        ListMoveObservable.notifyMoveChange(5)
      }
    }
  }

  static register(vueIns) {
    if (this.moveObservers.indexOf(vueIns) < 0) {
      this.moveObservers.push(vueIns)
    }
  }

  static unRegister(vueIns) {
    let index = this.moveObservers.indexOf(vueIns)
    if (index > -1) {
      this.moveObservers.splice(index, 1)
    }
  }

  static clearAll() {
    this.moveObservers.splice(0, this.moveObservers.length)
  }

  static attachWindow() {
    window.addEventListener('touchstart', this.touchStartListener)
    window.addEventListener('touchmove', this.touchMoveListener)
    window.addEventListener('touchend', this.touchEndListener)
  }

  static detachWindow() {
    window.removeEventListener('touchstart', this.touchStartListener)
    window.removeEventListener('touchmove', this.touchMoveListener)
    window.removeEventListener('touchend', this.touchEndListener)
  }

  static notifyMoveChange(direction, reachBoundary) {
    for (let i = 0; i < this.moveObservers.length; i++) {
      switch (direction) {
        case 1:
          this.moveObservers[i].up && this.moveObservers[i].up(reachBoundary)
          break
        case 2:
          this.moveObservers[i].down && this.moveObservers[i].down(reachBoundary)
          break
        case 3:
          this.moveObservers[i].left && this.moveObservers[i].left()
          break
        case 4:
          this.moveObservers[i].right && this.moveObservers[i].right()
          break
        case 5:
          this.moveObservers[i].click && this.moveObservers[i].click()
          break
        case 6:
          this.moveObservers[i].longClick && this.moveObservers[i].longClick()
          break
      }

    }
  }

  static isElementNotInViewPort(el) {
    if (el) {
      let rect = el.getBoundingClientRect()
      return (rect.top >= (window.innerHeight || document.documentElement.clientHeight) || rect.bottom <= 0)
    }
  }

};




// WEBPACK FOOTER //
// ./src/utils/listmoveutils.js